'use client';

import { useStore } from '@/providers/app-store-provider';
import { env } from '@/utils/env';
import { useEffect } from 'react';

// 核心业务路径特征
// const CRITICAL_PATHS = ['/cart', '/checkout', '/payment', '/goods-detail', '/product-list'];
const CRITICAL_PATHS = [];
const ARMS_SAMPLE_RATE = 0.05;

export default function ArmsRumTracker() {
  const userInfo = useStore((state) => state.userInfo);

  useEffect(() => {
    // 仅在客户端且非本地环境初始化
    if (
      typeof window !== 'undefined' &&
      env.NEXT_PUBLIC_ENV !== 'local' &&
      env.NEXT_PUBLIC_ENABLE_ARMS === 'true' &&
      env.NEXT_PUBLIC_ARMS_ENDPOINT
    ) {
      // @ts-ignore
      import('@arms/rum-browser/dist/browser-sdk.js').then(({ default: ArmsRum }) => {
        try {
          ArmsRum.init({
            // pid: env.NEXT_PUBLIC_ARMS_PID, // 新版 endpoint 已包含 service_id，无需 pid
            endpoint: env.NEXT_PUBLIC_ARMS_ENDPOINT,
            env: env.NEXT_PUBLIC_ENV === 'production' ? 'prod' : 'pre',

            // 【成本控制】全局采样率 5%
            sessionConfig: {
              sampleRate: ARMS_SAMPLE_RATE,
              storage: 'localStorage',
            },

            // 【白屏监控】基于 DOM 检测
            whiteScreen: {
              rootId: 'body',
              // screenshot: true // 开启异常截图，需要配合OSS上传，暂不开启
            },

            // 【智能过滤】
            filters: {
              // 过滤 PV 上报
              // @ts-ignore - Arms SDK 类型定义缺失 pv 字段
              pv: () => {
                const currentPath = location.pathname;
                const isCritical = CRITICAL_PATHS.some((path) => currentPath.includes(path));

                // 如果是重点页面，保留数据
                if (isCritical) return true;

                // 如果是非重点页面，再进行一次随机采样，保留 5%
                return Math.random() < ARMS_SAMPLE_RATE;
              },
              // 过滤非核心页面的成功 API 日志
              // @ts-ignore - Arms SDK 类型定义不准确
              api: (event: any) => {
                // 错误日志永远上报
                if (event.code !== '200' && event.success === false) return true;
                // 核心页面全量上报
                if (CRITICAL_PATHS.some((path) => location.pathname.includes(path))) return true;
                // 其他页面过滤成功日志
                return false;
              },
              // 静态资源同理
              resource: (event: any) => {
                if (!event.success) return true;
                return CRITICAL_PATHS.some((path) => location.pathname.includes(path));
              },
            },

            spaMode: 'history',

            // 【路由聚合】将 /goods-detail/sku123 聚合为 /goods-detail/:sku
            parseViewName: (url: string) => {
              if (url.includes('/goods-detail/')) return '/goods-detail/:sku';
              if (url.includes('/account/order-detail/')) return '/account/order-detail/:id';
              if (url.includes('/product-list/')) return '/product-list/:id';
              return url;
            },
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('ARMS init error:', error);
        }
      });
    }
  }, []);

  // 【用户关联】
  useEffect(() => {
    if (userInfo?.id) {
      // @ts-ignore
      import('@arms/rum-browser/dist/browser-sdk.js').then(({ default: ArmsRum }) => {
        try {
          ArmsRum.setConfig('user', {
            id: String(userInfo.id),
            tags: `vip_${userInfo.member_level}`,
          });
        } catch {
          // ignore
        }
      });
    }
  }, [userInfo]);

  return null;
}
